<div class="container-right-main fluid-container">
    <div class="top-right-div">
    <div class="display-flex">
        <div class="float-left">
                <div class="title" *ngIf="!selectedSourceName">
                Data Source : {{dataCount}} - AMP
                </div>

                <div  class="back-btn-new" (click)="backButton()" *ngIf="selectedSourceName">
                    <img  src="../../../assets/images/back_button_popup.svg" alt="Back-Button">
                </div>
                <div class="title" *ngIf="selectedSourceName">
                    {{ selectedSourceName }}
                </div>
        </div>
        <div class="float-right">
            &nbsp;
        </div>
    </div>
    

    <div class="display-flex">
        <div class="float-left">
            &nbsp;
        </div>
        <div class="float-right">
            <div class="filter-search-outer">
                <div class="filter-search-wrapper">
                    <form [formGroup]="filterForm">
                    <input #searchInput placeholder="Search with ..." class="filter-search"
                        (input)="applyFilter(searchInput.value)" formControlName="searchInput">
                    <div class="search-icon">
                        <img src="../../../assets/icons/icon-search-new.svg" width="19.8" height="20.51" />
                    </div>
                    </form>
                </div>
                
                <div class="filter-msg" *ngIf="showNoSearchResultsMessage">
                    No search results found.
                </div>
            </div>
        </div>
    </div>
    <div class="sec-row">
        <div class="sr-left-div">
            <!-- <span> {{ filteredDataSource.data.length }} Files</span> -->
            <!--  <span>Last Updated on 12-12-2024 07:01 AM</span> -->
        </div>
 
        
        
    </div>
    <!-- <div class="d-flex align-right">
        <button (click)="openCreateSourceDialog()" class="btn-white">+ New Data Source</button>
    </div> -->
    <div id="loader" class="loader"></div>
    <div class="bottom-table">
        <div class="overflowxauto">
            <table class="assignee-table mat-elevation-z7" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
                <!-- <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Title
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> 
                        <span [innerHTML]="element.title"></span>
                    </td>
                  </ng-container> -->
                  <ng-container matColumnDef="source_file">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  mat-sort-header="source_file" class="tab-th">
                        Source File
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td">
                        <span *ngIf="!selectedSourceName" (click)="showDetails(element)" class="clickable-row">
                            {{ element.source_file }}
                        </span> 
                        <span *ngIf="selectedSourceName">
                            {{ element.source_file }}
                        </span> 
                    </td>
                    <!-- <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.source_file }}</td> -->
                  </ng-container>

                  <ng-container matColumnDef="asset_type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" mat-sort-header="asset_type"  class="tab-th">
                        Asset Type
                    </th>
                    <td mat-cell *matCellDef="let element"  class="tab-td"> {{element.asset_type}} </td>
                  </ng-container>

                <ng-container matColumnDef="amp_adptr_created_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" mat-sort-header="amp_adptr_created_at" class="tab-th">
                        Created Date
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.amp_adptr_created_at | date: 'MM-dd-yyyy hh:mm a'}} </td>
                  </ng-container>

                  <ng-container matColumnDef="expiration_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" mat-sort-header="expiration_date"  class="tab-th">
                        Expiration Date
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.expiration_date | date: 'MM-dd-yyyy hh:mm a'}}</td>
                  </ng-container>
 
                  <!-- <ng-container matColumnDef="amp_adptr_created_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        amp_adptr_created_at
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.amp_adptr_created_at}} </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="source_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Source name
                    </th>
                    <td mat-cell *matCellDef="let element"  class="tab-td"> {{element.source_name}} </td>
                  </ng-container> -->
                    <!-- <ng-container matColumnDef="amp_status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        AMP Status
                    </th>
                    <td mat-cell *matCellDef="let element"  class=" tab-td"> {{element.amp_status}} </td>
                  </ng-container> -->
 
                  <ng-container matColumnDef="modifiedon">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" mat-sort-header="modifiedon" class="tab-th">
                        Modified On
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.modifiedon | date: 'MM-dd-yyyy hh:mm a'}}</td>
                  </ng-container>
 
                  <!-- <ng-container matColumnDef="cdn_url">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" mat-sort-header="cdn_url" class="tab-th">
                        CDN URL
                    </th>
                    <td mat-cell *matCellDef="let element" class="clickable-row tab-td" (click)="goToLink(element.cdn_url)"> {{ element.cdn_url }} </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="embedding_proc_status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Embedding Process Status
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ convertUtcToLocal(element.embedding_proc_status) }}</td>
                  </ng-container>
                  <ng-container matColumnDef="error_desc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Error Description
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.error_desc}}</td>
                  </ng-container>
                
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Id
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.id }}</td>
                  </ng-container>
                  <ng-container matColumnDef="language">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Language
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.language }}</td>
                  </ng-container> -->
                 
                  <!-- <ng-container matColumnDef="primary_market_approved_for">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                       Primary Market Approved For
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.primary_market_approved_for }}</td>
                  </ng-container>
                  <ng-container matColumnDef="primary_platform_category">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Primary Platform Category
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.primary_platform_category }}</td>
                  </ng-container>
                  <ng-container matColumnDef="source_file">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Source File
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="showDetails(element)" class="clickable-row tab-td"> {{ element.source_file }}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Status
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.status }}</td>
                  </ng-container>
                  <ng-container matColumnDef="status_readonly">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Status read only
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.status_readonly }}</td>
                  </ng-container> -->
                  
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
 
            </table>
        </div>     
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>
</div>